import axios from 'axios';
import { Notification } from 'element-ui';
import { GetAuthToken } from 'rj-server-auth-token';
import { readErrorBlob, jumpShutDownPage } from '@/libs/util';
import { getSign } from './requestEncryption';
import Cookies from 'js-cookies';

import { creditTransferConfirmedList } from '@/mock/creditTransfer';
import { invoiceNoticePendingList, invoiceNoticeCreatedList } from '@/mock/invoiceNoticeManagement';

const normalizeText = (value) => String(value || '').trim();

// let querystring = require('querystring');
// 允许跨域请求发送cookie
axios.defaults.withCredentials = true;
axios.defaults.baseURL = `${window._env_.VUE_APP_REQUEST_ADDRESS}/${window._env_.VUE_ENVIRONMENT_ALL}/`;
// axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/order-lifecycle-uat02' : '/order-lifecycle-uat02';
// axios.defaults.headers.post['Content-Type'] = 'application/json'; // application/x-www-form-urlencoded , multipart/form-data
// http请求拦截
axios.interceptors.request.use(
  config => {
    // if (config.headers.common.Accept.indexOf('application/json') >= 0) {
    //   // config.data = querystring.stringify(config.data);
    //   console.log(config);
    //
    // }timeOut:
    config.headers['web-sign-server-auth'] = GetAuthToken({
      sysId: 'c0c73417cf58cb87e146a78f6e44ef44',
      accessKeySecret: '7B3A866D-7343-540C-30FD-0E71BE1B667B'
    });
    config.headers['sysId'] = 'c0c73417cf58cb87e146a78f6e44ef44';
    config.headers['timeOut'] = new Date().getTime();

    config.headers['sid_login'] = localStorage.getItem('sidLogin') && JSON.parse(localStorage.getItem('sidLogin') || '');
    config.headers['union_session_ticket'] = localStorage.getItem('union_session_ticket');

    let timestamp = localStorage.getItem('timestamp');
    if (timestamp && timestamp + 600000 > new Date().getTime()) {
      timestamp = new Date().getTime();
      localStorage.setItem('timestamp', timestamp);
    } else {
      timestamp = new Date().getTime();
    }
    const sign = getSign(config, axios, timestamp);
    console.log(sign);
    config.headers['sign'] = sign;
    config.headers['timestamp'] = timestamp;

    return config;
  },

  error => {
    return Promise.reject(error);
  }
);

// http响应拦截器
axios.interceptors.response.use(
  async res => {
    console.log(res, 'res');
    let json = res.data;
    // 停机维护
    if (res.data && res.data.status === '503') {
      jumpShutDownPage(res.data.data);
    }

    const contentType = (res.headers && res.headers['content-type']) || '';

    if (contentType.indexOf('application/octet-stream') >= 0) {
      return res;
    }

    // 导出Pi成功时,直接返回文件流
    if (contentType.indexOf('application/vnd.ms-excel') > -1) {
      return res;
    }

    // 文件流响应（Blob）直接返回；仅当后端返回 JSON 报错体时才转成 json 继续向下
    if (res.data instanceof Blob) {
      if (res.data.type === 'application/json') {
        let data = await readErrorBlob(res.data);
        res.data = data;
        json = data;
      } else {
        return res;
      }
    }

    const skipGlobalError = res.config && res.config.skipGlobalError;
    if (!skipGlobalError && json && json.status !== '200' && json.status !== '302' && json.status !== 'SSO-100023' && json.status !== 'SSO-100024') {
      const notifyMessage = json.error || json.err || json.msg || json.message;
      if (!notifyMessage) {
        return res;
      }
      if (json.status === '7777') {
        Notification.warning({
          message: notifyMessage
        });
      } else {
        Notification.error({
          message: notifyMessage
        });
      }
    }

    // else if (json && json.status === '302') {

    // }
    return res;
  },
  error => {
    // console.log('lanjieqi');
    // Notification.error({
    //   message: '请求服务器失败'
    // });
    if (error.message.includes('428')) {
      Cookies.removeItem('ruijieportal', '/', '.ruijie.com.cn');
      Cookies.removeItem('PartnerUser', '/', '.ruijie.com.cn');
      Cookies.removeItem('phplogin', '/', '.ruijie.com.cn');
      Cookies.removeItem('thh_auth', '/', '.ruijie.com.cn');
      Cookies.removeItem('sid_login', '/', '.ruijie.com.cn');
      // 干掉切换的渠道
      Cookies.removeItem('xsyx_chang_user', '/', '.ruijie.com.cn');
      window.localStorage.removeItem('union_session_ticket');
      if (window._env_.NODE_ENV !== 'pro') {
        window.location.href = `${window.location.origin}/toLoginPage`;
      } else {
        window.location.href = `https://ces.ruijie.com.cn/toLoginPage`;
      }
      // return Notification.warning({
      //   message: '登录验证失败或登录已失效，请重新登录'
      // });
    }
    return Promise.reject(error);
  }
);
// axios 具体使用 请参考 https://github.com/axios/axios
export default axios;

/** 调用 order-lifecycle 通用出口合规检测接口。 */
export const requestExportComplianceDetection = (params) => axios.post('/exportCompliance/detect', params);
/** 调用 order-lifecycle 创建出口合规审查单接口。 */
export const requestExportComplianceReviewCreation = (params) => axios.post('/exportCompliance/review/create', params);
export const userLogin = (ticket) => axios.get('/user/user', { params: { ticket } });
export const fileupload = (params) => axios.post('/exchangegoods/file/upload', params.data, params.config);
export const getApprovalOrderList = (params) => axios.post('/orderInfo/getApprovalOrderList', params); // 订单代办列表
export const getAlreadyDoneOrderList = (params) => axios.post('/orderInfo/getAlreadyDoneOrderList', params); // 订单已办列表
export const getPreferredOrderToDoList = (params) => axios.post('/orderInfo/getPreferredOrderToDoList', params); // 优选订单代办列表
export const getPreferredOrderAlreadyDoneList = (params) => axios.post('/orderInfo/getPreferredOrderAlreadyDoneList', params); // 优选订单已办列表
export const getjtoken = (params) => axios.post('/getjtoken', params);
export const getLoginUser = () => axios.get('/user/getLoginUser', { params: { loginType: localStorage.getItem('loginType') || undefined } });
export const getUserPermissionMenuCatalog = () => axios.get('/userPermissionConfig/menuCatalog');
export const getUserPermissionDetail = (userId) => axios.get('/userPermissionConfig/detail', { params: { userId } });
export const saveUserPermissionConfig = (params) => axios.post('/userPermissionConfig/save', params);
export const searchUserPermissionUser = (keyword) => axios.get('/userPermissionConfig/searchUser', { params: { keyword } });
export const getPermissionMenuList = () => axios.get('/userPermissionConfig/menuList');
export const addPermissionMenu = (params) => axios.post('/userPermissionConfig/menuAdd', params);
export const updatePermissionMenu = (params) => axios.post('/userPermissionConfig/menuUpdate', params);
export const deletePermissionMenu = (params) => axios.post('/userPermissionConfig/menuDelete', params);

/** CES 角色审批人配置 */
export const searchCesUserRoleUser = (keyword) => axios.get('/cesUserRoleConfig/searchUser', { params: { keyword } });
export const listCesRoles = (tag) => axios.get('/cesUserRoleConfig/listRoles', { params: tag == null || tag === '' ? {} : { tag } });
export const listCesRoleBindings = (params) => axios.get('/cesUserRoleConfig/listBindings', { params });
export const bindCesUserRole = (params) => axios.post('/cesUserRoleConfig/bind', params);
export const unbindCesUserRole = (params) => axios.post('/cesUserRoleConfig/unbind', params);
export const saveCesLeaderRelation = (params) => axios.post('/cesUserRoleConfig/saveLeaderRelation', params);
export const deleteCesLeaderRelation = (params) => axios.post('/cesUserRoleConfig/deleteLeaderRelation', params);

/** 字典字段管理 */
export const listSysDictTypes = (keyword) => axios.get('/sysDictDataConfig/listTypes', { params: keyword ? { keyword } : {} });
export const listSysDictByType = (params) => axios.get('/sysDictDataConfig/listByType', { params });
export const createSysDictData = (params) => axios.post('/sysDictDataConfig/create', params);
export const updateSysDictData = (params) => axios.post('/sysDictDataConfig/update', params);
export const deleteSysDictData = (params) => axios.post('/sysDictDataConfig/delete', params);
export const getOrderDate = (documentID) => axios.get('/orderInfo/getOrderDate', { params: { documentID } }); // 获取签署合同进度信息
export const getProcessInfoList = (documentID) => axios.get('/orderInfo/getProcessInfoList', { params: { documentID } }); // 获取办理过程集合信息
export const getBaseOrderDetailInfo = (params) => axios.get('/orderInfo/getBaseOrderDetailInfo', { params }); // 获取订单基础信息
export const getIsCurrentApprover = (strDocmentId) => axios.get('/orderInfo/getIsCurrentApprover', { params: { strDocmentId } }); // 获取订单基础信息
export const getPreferredBaseOrderDetailInfo = (documentID) => axios.get('/orderInfo/getPreferredBaseOrderDetailInfo', { params: { documentID } }); // 获取优选服务商订单详情
export const getContactInfo = (code) => axios.get('/orderInfo/getContactInfo', { params: { code } }); // 获取渠道联系方式
export const getOrderProductInfo = (params) => axios.get('/orderInfo/getOrderProductInfo', { params }); // 获取订单产品信息列表
export const IntegratorsConfirmOrRefusOrder = (params) => axios.post('/orderInfo/IntegratorsConfirmOrRefusOrder', params); // 首级商确认接单、拒绝接单操作
export const distributorConfirmOrRefusOrder = (params) => axios.post('/orderInfo/distributorConfirmOrRefusOrder', params); // 首级商确认接单、拒绝接单操作
export const confirmOrRefuseOrder = (params) => axios.post('/orderInfo/confirmOrRefuseOrder', params); // 优选服务分销商确认接单、拒绝接单操作
export const getContractDetailAllInfoByConNum = (contractNum, expectedDateFlag = false) => axios.get('/contract/getContractDetailAllInfoByConNum', { params: { contractNum, expectedDateFlag } }); // 根据合同编号获取合同相关详细信息
export const getTwentyFirstCommitmentRequiredDeliveryDate = (opportunityCode) => axios.get('/contract/getTwentyFirstCommitmentRequiredDeliveryDate', { params: { opportunityCode } });
export const isEbgDeliveryPilotArea = (departmentCode, createTime) => axios.get('/ebgDeliveryPilot/isPilotArea', { params: { departmentCode, createTime } });
// 获取币种类型数据
export const dictGetDictData = (params) => axios.get('/dict/getDictData', { params }); // 获取币种类型数据
// 获取电汇单（商务）
export const listAssignTelegraphicTransferInternation = (params) => axios.post('/telegraphicTransferInternation/listAssignTelegraphicTransferInternation', params);
export const listAssignTelegraphicTransferInternationBusiness = (params) => axios.post('/telegraphicTransferInternation/listAssignTelegraphicTransferInternationBusiness', params);
// 分配（商务）
export const assignTelegraphicTransferInternation = (params) => axios.post('/telegraphicTransferInternation/assignTelegraphicTransferInternation', params);

export const selectAssignInfoByUserCode = () => axios.get('/contractAssign/selectAssignInfoByUserCode'); // 根据用户标识查询电汇列表
export const selectContractSort = (userCode) => axios.get('/contract/selectContractSort'); // 查询合同不同状态数量
export const selectContractInfoList = (params) => axios.post('/contract/selectContractInfoList', params); // 分页查询待提交、待盖章、待付款、全部订单合同信息
export const selectSpecialContractInfoList = (params) => axios.post('/contract/selectSpecialContractInfoList', params); // 查询战略备货合同列表
export const queryShippingInfoSpecialProducts = (contractId) => axios.get('/strategyShipment/queryShippingInfoSpecialProducts', { params: { contractId } }); // 查询战略合同的发货信息
export const querySpecialInvoiceDetail = (id) => axios.get('/strategyShipment/querySpecialInvoiceDetail', { params: { id } }); // 通过发货单id查询发货详情

// CES多地址
export const queryIsMoreAddress = (params) => axios.post('/freight/checkMultipleAddressesDifference', params);
export const moreAddressComputedFee = (params) => axios.post('/freight/freightMultipleAddressesDifference', params);
export const getContractProsAndSpecialProsDetial = (contractId, isSon) => axios.get('/contractProduct/getContractProsAndSpecialProsDetail', { params: { contractId, isSon } });
export const queryOrderInfoFromDsDataByAddress = (params) => axios.get('/contract/queryOrderInfoFromDsDataByAddress', { params });
export const getContractProsAndSpecialProsByAddress = (contractId, isSon) => axios.get('/contractProduct/getContractProsAndSpecialProsByAddress', { params: { contractId, isSon } });

/**
 * @desc 根据合同id获取产品信息列表
 * @param {String} contractId 合同id
 * @param {String} contractType 合同类型
 * @param {boolean} asInterDirect 是否直签
*/
export const getContractProductInfoByContractNum = (contractId, contractType = null, asInterDirect = null) => axios.get('/contractProduct/queryContractProductInfoByContractNum', { params: { contractId, contractType, asInterDirect } });
export const previewSalesBorrowServiceReturn = (params) => axios.post('/sales-borrow-service-return/preview', params);
export const createSalesBorrowServiceReturn = (params) => axios.post('/sales-borrow-service-return/applications', params);
export const updateSalesBorrowServiceReturn = (applicationId, params) => axios.put(`/sales-borrow-service-return/applications/${applicationId}`, params);
export const getSalesBorrowServiceReturn = (applicationId) => axios.get(`/sales-borrow-service-return/applications/${applicationId}`);
export const submitSalesBorrowServiceReturn = (applicationId) => axios.post(`/sales-borrow-service-return/applications/${applicationId}/submit`);
export const recallSalesBorrowServiceReturn = (applicationId, params) => axios.post(`/sales-borrow-service-return/applications/${applicationId}/recall`, params);
export const approveSalesBorrowServiceReturn = (applicationId, params) => axios.post(`/sales-borrow-service-return/applications/${applicationId}/approve`, params);
export const rejectSalesBorrowServiceReturn = (applicationId, params) => axios.post(`/sales-borrow-service-return/applications/${applicationId}/reject`, params);
export const getContractProductInfoByContractId = (contractId, contractType = null, asInterDirect = null, expectedDateFlag = false, contractNum = null) => axios.get('/contractProduct/getContractProductInfoByContractId', { params: { contractId, contractType, asInterDirect, expectedDateFlag, contractNum } });
export const getContractNumber = (documentID) => axios.get('/orderInfo/getContractNumber', { params: { documentID } }); // 根据订单编码获取合同编码
export const getContractInfoByDocumentId = (documentId) => axios.get('/contract/getContractInfoByDocumentId', { params: { documentId } }); // 根据订单编码获取合同编码
export const getSupplyUnitList = () => axios.get('/contract/getSupplyUnitList'); // 获取供货单位列表
export const attachmentGetToken = () => axios.get('/attachment/getToken'); // 文件服务生成token
export const getAttachmentListByContractId = (contractId) => axios.get('/attachment/getAttachmentListByContractId', { params: { contractId } }); // 根据合同id获取合同附件列表
export const deleteByContractIdAndAttachmentId = (params) => axios.get('/attachment/deleteByContractIdAndAttachmentId', { params }); // 根据合同id和附件id删除附件（软删除）
export const getDeliveryReceiptList = (params) => axios.post('/deliveryReceipt/getDeliveryReceiptList', params); // 查询待-已收货列表
export const comfirmReceipt = (params) => axios.post('/deliveryReceipt/confirmReceipt', params); // 代理商确认收货
export const getDeliveryReceiptProductListByNum = (receiptNumber, contractCode, orderNumber) => axios.get('/deliveryReceipt/getDeliveryReceiptProductListByNum', { params: { receiptNumber, contractCode, orderNumber } }); // 根据收货单发货产品列表
export const getReceiptEnclosureList = (documentId, receiptNumber) => axios.get('/deliveryReceipt/getReceiptEnclosureList', { params: { documentId, receiptNumber } }); // 查询回执单附件列表
export const deleteReceiptEnclosureList = (params) => axios.post('/deliveryReceipt/deleteReceiptEnclosureList', params); // 批量删除回执单

export const uploadAfterSaveInfo = (params) => axios.post('/attachment/uploadAfterSaveInfo', params); // 合同附件上传成功后保存信息到数据库
export const getTokenForDownZip = (params) => axios.post('/attachment/getTokenForDownZip', params); // 文件服务批量下载生成token
export const getTokenForDownZipV2 = (params) => axios.post('/attachment/getTokenForDownZip_V2', params); // 文件服务批量下载生成token
export const getProvinceList = (params) => axios.get('/region/getNewProvinceList'); // 获取省份列表
export const getChildAddress = (params) => axios.get('/region/getNewChildAddress', { params }); // 获取省份列表
export const getReceiptAddressByContractId = (contractId) => axios.get('/receiptAddressInfo/getReceiptAddressByContractId', { params: { contractId } }); // 根据合同ID获取所选收货地址

// 根据合同编号获取所选收货地址
export const getReceiptAddressByContractNum = (params) => axios.get('/receiptAddressInfo/getReceiptAddressByContractNum', { params });

// 查询换货合同送货地址的信息
export const aggetReceiptAddressByContractNum = (params) => axios.get('/returns/ag/getReceiptAddressByContractNum', { params });

export const getReceiptAddressInfoList = () => axios.get('/receiptAddressInfo/getReceiptAddressInfoList'); // 获取收货地址列表
export const getPageReceiptAddressList = (params) => axios.post('/receiptAddressInfo/getPageReceiptAddressList', params); // 获取收货地址列表分页版本
export const settingDefaultValues = (id) => axios.get('/receiptAddressInfo/settingDefaultValues', { params: { id } }); // 设置默认收获地址
export const getReceiptAddressInfoModel = (id) => axios.get('/receiptAddressInfo/getReceiptAddressInfoModel', { params: { id } }); // 获取收货地址model
export const deleteReceiptAddressInfo = (id) => axios.get('/receiptAddressInfo/deleteReceiptAddressInfo', { params: { id } }); // 软删除收获地址
export const saveReceiptAddressInfo = (params) => axios.post('/receiptAddressInfo/saveReceiptAddressInfo', params); // 文件服务批量下载生成token
export const assignTransfer = (params) => axios.post('/contractAssign/assignTransfer', params); // 分配电汇记录（插入电汇分配表，更新电汇单表）
export const dealtContractToAssignInfoListTransfer = (params) => axios.post('/contractAssign/dealtContractToAssignInfoListTransfer', params); // 待办合同款项分配 - 确认分配
export const dealtInterContractToAssignInfoListTransfer = (params) => axios.post('/overseasExOrder/dealtContractToAssignInfoListTransfer', params); // 国际待办合同款项分配 - 确认分配

export const getFloor = () => axios.get('/receiptAddressInfo/getFloor'); // 获取搬运楼层
export const getAddrestLabel = () => axios.get('/receiptAddressInfo/getAddrestLabel'); //  获取地址标签
export const getDeliveryDetailsList = (strContractCode) => axios.get('/contract/getDeliveryDetailsList', { params: { strContractCode } }); //  根据合同编码获取发货明细列表
export const getInterDeliveryNewDetailsList = (contractCode) => axios.get('/overseasExOrder/getInterDeliveryDetailsList', { params: { contractCode } }); //  国际根据合同编码获取发货明细列表

export const getDeliveryDetails = (strContractCode, strInvoiceNumber, specialProduct) => axios.get('/contract/getDeliveryDetails', { params: { strContractCode, strInvoiceNumber, specialProduct } }); //  根据合同编码、物流编码获取发货明细
export const getInterDeliveryDetails = (strContractCode, strInvoiceNumber, specialProduct) => axios.get('/overseasExOrder/getDeliveryDetails', { params: { strContractCode, strInvoiceNumber, specialProduct } }); //  根据合同编码、物流编码获取发货明细
export const getSellingBackList = (strContractCode) => axios.get('/contract/getSellingBackList', { params: { strContractCode } }); //  根据合同编码获取销退数据列表
export const agGetInvoiceDetails = (params) => axios.get('/returns/ag/getInvoiceDetails', { params: params }); //  根据合同编码获取开票明细
export const getInvoiceDetails = (strContractCode) => axios.get('/contract/getInvoiceDetails', { params: { strContractCode } }); //  根据合同编码获取开票明细
export const getInterInvoiceDetails = (contractCode, projectName) => axios.get('/overseasExOrder/getInvoiceDetails', { params: { contractCode, projectName } }); //  国际根据合同编码获取开票明细

export const getSerialNumberListByContract = (strContractCode, productName, specialProduct) => axios.get('/contract/getSerialNumberListByContract', { params: { strContractCode, productName, specialProduct } }); // 根据合同编码获取序列号列表
export const getAgreedDeliveryDate = (strContractCode) => axios.get('/contract/getAgreedDeliveryDate', { params: { strContractCode } }); //  根据合同编码获取约定交付日期列表
export const getContractTrackingList = (contractNum) => axios.get('/contract/getContractTrackingList', { params: { contractNum } }); //  根据合同编码获取约定交付日期列表
export const getContractInfoAddressList = (strContractCode) => axios.get('/contract/getContractInfoAddressList', { params: { strContractCode } }); //  根据合同编码获取订单明细-地址列表
export const getContractInfoDeatil = (strContractCode, strAddressName) => axios.get('/contract/getContractInfoDeatil', { params: { strContractCode, strAddressName } }); //  根据合同编码、地址名称获取订单明细-产品列表
export const getDesensitizationContractInfoDeatil = (strContractCode, strAddressName) => axios.get('/contract/getDesensitizationContractInfoDeatil', { params: { strContractCode, strAddressName } }); //  根据合同编码、地址名称获取订单明细-产品列表

export const selectAssignDetailByContractId = (contractId) => axios.get('/contract/selectAssignDetailByContractId', { params: { contractId } }); // 根据合同id获取合同详情电汇分配明细
export const selectInterByContractId = (contractId) => axios.get('/overseasExOrder/selectByContractId', { params: { contractId } }); // 国际根据合同id获取合同详情电汇分配明细

// 查询退款明细
export const agSelectAssignDetailByContractId = (params) => axios.get('/returns/ag/selectAssignDetailByContractId', { params });
export const selectDesensitizationAssignDetailByContractId = (contractId) => axios.get('/contract/selectDesensitizationAssignDetailByContractId', { params: { contractId } }); // 根据合同id获取合同详情电汇分配明细
export const getOrderType = () => axios.get('/common/getOrderType'); // 获取订单分类列表
export const getLogisticsInfoToList = (code, exp = '') => axios.get('/common/getLogisticsInfoToList', { params: { code, exp } }); // 根据物流编码获取物流轨迹
export const electronicSignature = (contractId) => axios.get('/signature/electronicSignature', { params: { contractId } }); // 合同电子签章
export const cancelContract = (contractId) => axios.get('/contract/cancelContract', { params: { contractId } }); // 代理商取消合同
export const printContractPDF = (contractId) => axios.get('/contract/printContractPDF', { params: { contractId } }); // 打印合同pdf
export const saveContractInfo = (params) => axios.post('/contract/saveContractInfo', params); // 提交合同信息并前去盖章
export const submitToPayment = (params) => axios.post('/contract/submitToPayment', params); // 提交合同信息并前去盖
export const canclePayMoney = (contractAssignId) => axios.get('/contractAssign/cancelContractAssignById', { params: { contractAssignId } }); // 代理商撤销分配款项
export const exportAllNotDelivered = () => axios.get('/export/getExportAgreedDeliveryDateAll', { responseType: 'blob' });// 导出欠货报表
export const selectExportPartialInvoice = () => axios.get('/partialInvoice/selectExportPartialInvoice', { responseType: 'blob' });// 导出欠货报表

/**
 * 订单员部分
 */
export const getOrdersContractList = (params) => axios.post('/contract/getOrdersContractList', params); // 分页查询合同列表 - 订单员
export const getBankInfoBySupplyUnitCode = (params) => axios.get('/contract/getBankInfoBySupplyUnitId', { params }); // 根据供货单位id获取银行列表
export const getOrderUnitList = (params) => axios.post('/common/getOrderUnitList', params); // 获取订货单位列表
export const getSaleArea = (strSaleAreaName) => axios.get('/common/getSaleArea', { params: { strSaleAreaName } }); // 获取区域列表
export const getAssistantInfo = (strAssistantUserName) => axios.get('/common/getAssistantInfo', { params: { strAssistantUserName } }); // 获取区域商务专员列表
export const getIntAll = (strAgentName) => axios.get('/common/getIntAll', { params: { strAgentName } }); // 获取区域商务专员列表
export const getCountryOrSpecificationPowerCord = (strCountryName, pinType) => axios.get('/common/getCountryOrSpecificationPowerCord', { params: { strCountryName, pinType } }); // 获取销往国家和电源线规格
export const getMarketSegment = (contractType) => axios.get('/common/getMarketSegment', { params: { contractType } }); // 获取细分市场列表
export const getOccasion = (strMarketSegmentID, contractType) => axios.get('/common/getOccasion', { params: { strMarketSegmentID, contractType } }); // 根据细分市场编码获取应用场合列表
export const getScenarios = (strApplicationID, contractType) => axios.get('/common/getScenarios', { params: { strApplicationID, contractType } }); // 根据应用场合编码获取应用场景列表

export const createContractNum = (splitType, contractType, newContract) => axios.get('/contract/createContractNum', { params: { splitType, contractType, newContract } }); // 创建合同编码
export const getOrderTypesBySupplyUnit = (supplyUnitID, currencyId) => axios.get('/common/getOrderTypesBySupplyUnit', { params: { supplyUnitID, currencyId } }); // 获取订单类型列表
export const getUserByName = (strUserName) => axios.get('/common/getUserByName', { params: { strUserName } }); // 获取外销、售前名称列表

export const saveOrderContractInfo = (params) => axios.post('/orderHandler/saveOrderContractInfo', params); // 订单员创建 国内合同 保存合同信息
/**
 * @desc 选择产品信息
 * @param {String} strProductName 产品名称
 * @param {String} contractType 合同类型
 * @param {boolean} asInterDirect 是否直签
*/
export const getAutoProductInfo = (strProductName, contractType = null, asInterDirect = null) => axios.get('/common/getAutoProductInfo', { params: { strProductName, contractType, asInterDirect } });

export const getMaterialByProductCode = (params) => axios.post('/contract/getMaterialByProductCode', params); // 获取料号信息  作废

export const getMaterialInfo = (params) => axios.post('/contract/getMaterialInfo', params); // 获取料号信息
export const getChannelRebate = (params) => axios.post('/contract/getChannelRebate', params); // 根据合同信息获取返利金额
export const createNewContract = (contractId) => axios.get('/orderHandler/createNewContract', { params: { contractId } }); // 订单员 生成新合同（原合同基础上）
export const rejectToAgent = (contractId) => axios.get('/orderHandler/rejectToAgent', { params: { contractId } }); // 订单员 驳回到代理商
export const getAutoDocumentTitle = (titleName) => axios.get('/common/getAutoDocumentTitle', { params: { titleName } }); // 根据项目名称模糊检索匹配项目列表
export const getRejectedList = (contractId) => axios.get('/approvalLog/getApprovalLogList', { params: { contractId } }); // 获取驳回意见列表
export const insertApprovalLog = (params) => axios.post('/approvalLog/insertApprovalLog', params);// 提交驳回意见
export const deleteDraftContract = (contractId) => axios.get('/contract/deleteContract', { params: { contractId } });// 订单员删除草稿合同
export const returnProduct = (params) => axios.get('/simpleMachine/returnProduct', { params });// 根据借用单号查询冲销产品
export const saveProductBorrowToSell = (params) => axios.post('/borrowToSell/saveProductBorrowToSell', params);// 根据借用单号查询冲销产品
export const checkLinePrice = (params) => axios.post('/contractProduct/checkLinePrice', params);// 云产品配置 校验
export const selectBorrowToSellListByContractId = (params) => axios.get('/borrowToSell/selectBorrowToSellListByContractId', { params });// 根据列表查找已选择序列号

/**
 * 电汇查询（代理商）
 */
export const billList = (params) => axios.post('/billList', params); // 电汇查询 - 代理商
export const getContractAssignInfoList = (orderUnit) => axios.get('/contract/getContractAssignInfoList', { params: { orderUnit } }); // 根据渠道名称获取未分配完成的合同列表
export const getContractAssignInfoListByTeleAndOrderUnit = (params) => axios.post('/contract/getContractAssignInfoListByTeleAndOrderUnit', params); // 根据渠道名称获取未分配完成的合同列表2
export const remittanceAssignToContractAmount = (params) => axios.post('/contractAssign/remittanceAssignToContractAmount', params); // 来款单分配 - 确认分配
export const selectBaseModelByTeleNum = (teleNum) => axios.get('/TelegraphicTransfer/selectBaseModelByTeleNum', { params: { teleNum } }); // 获取代理商申请退款页面信息
export const applyForRefund = (params) => axios.post('/TelegraphicTransfer/applyForRefund', params); // 代理商申请退款
export const checkApplyCount = (teleNum) => axios.get('/TelegraphicTransfer/checkApplyCount', { params: { teleNum } }); // 检查申请退款的次数（中途撤销退款的记录不算）
export const cancelApplyForRefund = (teleNum, primaryKey) => axios.get(`/TelegraphicTransfer/cancelApplyForRefund?teleNum=${teleNum}&primaryKey=${primaryKey}`);
export const updateContractStatusToSubmit = (contractId) => axios.get('/contract/updateContractStatusToSubmit', { params: { contractId } }); // 将合同状态更改为待提交
export const freightDifference = (params) => axios.post('/freight/freightDifference', params); // 校验是否含有电池和计算运费差价接口
/**
 * 电汇查询（财务）
 */
export const selectTelegraphicTransferList = (params) => axios.post('/TelegraphicTransfer/selectTelegraphicTransferList', params);
export const getTelegraphicBusiness = () => axios.get('/common/getTelegraphicBusiness'); // 业务实体列表-来款记录查询
export const getTelegraphicBank = () => axios.get('/common/getTelegraphicBank'); //  银行账号信息列表-来款记录查询(财务)
export const getElectronicTableData = (params) => axios.post('/invoice/agent/list', params); // 电子发票导出,列表接口
export const exportElectronicTableData = (params) => axios.post('/invoice/agent/export', params, {
  responseType: 'blob'
}); // 电子发票导出,列表接口
export const updateStatusByTeleNum = (params) => axios.post('/TelegraphicTransfer/updateStatusByTeleNum', params); //  废弃收款单，废弃条件：来款编号
export const updateImportCompanyByPrimaryKey = (params) => axios.post('/TelegraphicTransfer/updateImportCompanyByPrimaryKey', params); // 修改公司名称
export const financialCancellationTransfer = (params) => axios.post('/telFundManagementApproval/financialCancellationTransfer', params); // 废弃收款单，废弃条件：来款编号
export const importPayment = (params) => axios.post('/export/importPayment', params, { headers: { 'Content-Type': 'multipart/form-data' } }); // 上传excel
export const selectModelByTelegraphicTransferNum = (telegraphicTransferNum) => axios.get('/TelegraphicTransfer/selectModelByTelegraphicTransferNum', { params: { telegraphicTransferNum } }); // 电汇底单详细信息（包括在哪些合同上分配过的合同列表）
export const selectConfirmDetailByTeleNum = (teleNum) => axios.get('/TelegraphicTransfer/selectConfirmDetailByTeleNum', { params: { teleNum } }); // 账务退款的详细页面
export const createReceipt = (params) => axios.post('/TelegraphicTransfer/createReceipt', params); // 批量生成收款单
export const getFinalCustomerInfoList = (strFinalCustomerName) => axios.get('/common/getFinalCustomerInfoList', { params: { strFinalCustomerName } }); // 获取最终客户名称
export const confirmApplyForRefund = (teleNum, primaryKey, actionKey) => axios.get(`/TelegraphicTransfer/confirmApplyForRefund?teleNum=${teleNum}&primaryKey=${primaryKey}&actionKey=${actionKey}`); // 财务确认是否同意退款申请
export const getBankInfo = () => axios.get('/contract/getBankInfo'); // 获取银行账户
export const splitHardware = (contractId) => axios.get('/contract/splitHardware', { params: { contractId } }); // 合同软硬拆分
export const selectAssignInfoByUserCodeAndContractNum = (contractNum, contractType, oldContractNum) => axios.get('/contractAssign/selectAssignInfoByUserCodeAndContractNum', { params: { contractNum, contractType, oldContractNum } }); // 根据用户标识查询电汇列表2
export const postInterestDeliveryDate = (params) => axios.post('/contract/postInterestDeliveryDate', params); // 加急交期接口
export const getUrlByFileID = (fileID) => axios.get('/attachment/getUrlByFileID', { params: { fileID } }); // 根据id获取合同信息
// 退款申请分页列表（渠道、财务）
export const selectTelApplyRefund = (params) => axios.post('/telApplyRefund/selectTelApplyRefund', params);
// 根据电汇单编号查询退款信息
export const getRefundApplyInfoByTTNum = (params) => axios.get('/telApplyRefund/getRefundApplyInfoByTTNum', { params });
// 按支行名称查询客户支行及联行号
export const searchCustomerBankBranches = (branchName) => axios.get('/telApplyRefund/searchCustomerBankBranches', { params: { branchName } });
// 发起申请退款
export const telApplyRefundapplyRefund = (params) => axios.post('/telApplyRefund/applyRefund', params);
// 根据申请退款的id，获取退款详情
export const getRefundApplyInfo = (params) => axios.get('/telApplyRefund/getRefundApplyInfo', { params });
// 废弃退款流程
export const abandonRefund = (params) => axios.get('/telApplyRefund/abandonRefund', { params });
// 召回退款流程
export const recallRefund = (params) => axios.post('/telApplyRefund/recallRefund', params);
// 编辑退款流程
export const editRefund = (params) => axios.post('/telApplyRefund/editRefund', params);
// 办理（渠道、商务、财务）
export const transactTelApplyRefund = (params) => axios.post('/telApplyRefund/transactTelApplyRefund', params);

/** 国际退款三 Tab 列表（禁止复用 selectTelApplyRefund） */
export const overseasRefundSelectList = (params) => axios.post('/overseasRefund/selectList', params);

/** 国际退款详情 */
export const overseasRefundDetail = (params) => axios.get('/overseasRefund/detail', { params });

/** 国际退款已办详情（轮次快照） */
export const overseasRefundDetailBySnapshot = (params) => axios.get('/overseasRefund/detailBySnapshot', { params });

/** 国际退款办理（同意/驳回） */
export const overseasRefundTransact = (params) => axios.post('/overseasRefund/transact', params);

/** 国际退款召回 */
export const overseasRefundRecall = (params) => axios.post('/overseasRefund/recall', params);

/** 国际退款编辑重提 */
export const overseasRefundEdit = (params) => axios.post('/overseasRefund/edit', params);

/** 国际退款废弃 */
export const overseasRefundAbandon = (params) => axios.post('/overseasRefund/abandon', params);

// 分配电汇单列表
export const addReTelegraphicTransfer = (params) => axios.get('/returns/ag/addReTelegraphicTransfer', { params });
// 新增电汇单
export const assignSelectAssignInfoByUserCodeAndContractNum = (params) => axios.get('/assign/selectAssignInfoByUserCodeAndContractNum', { params });
// 国际退换货商务分配查询电汇单列表
export const selectInterAssignInfoByUserCodeAndContractNum = (params) => axios.get('/overseasExOrder/selectAssignInfoByUserCodeAndContractNum', { params });
// 新建电汇单
export const addOverseasAddReTelegraphicTransfer = (params) => axios.get('/overseasExOrder/overseasAddReTelegraphicTransfer', { params });

// 云桌面
export const checkCloudDesktopAuthorization = (productCodeArrayStr) => axios.post('/contract/checkCloudDesktopAuthorization', { 'productCodeArrayStr': productCodeArrayStr });// 检测是否包含云桌面指定的两款产品
export const getNoticeSendMailList = () => axios.get('/noticeSendMail/getNoticeSendMailList'); // 齐套通知打款邮箱列表
export const addNoticeSendMail = (setNoticeMail) => axios.get('/noticeSendMail/addNoticeSendMail', { params: { setNoticeMail } }); // 添加新元素至齐套通知打款邮箱列表

// 权限管理
export const getSelectInfoList = (params) => axios.post('/orderClerkPrivilege/selectInfoList', params); // 分页查询订单员权限信息管理
export const insertInfo = (params) => axios.post('/orderClerkPrivilege/insertInfo', params); // 新增订单员权限信息
export const updateInfo = (params) => axios.post('/orderClerkPrivilege/updateInfo', params); // 修改订单员权限信息
export const getOrderClerkByUserCodeAndTypeList = (userCode) => axios.get('/orderClerkPrivilege/getOrderClerkByUserCodeAndTypeList', { params: { userCode } }); // 回显订单员详情
export const deleteInfo = (params) => axios.post('/orderClerkPrivilege/deleteInfo', params); // 批量软删除订单员权限信息
export const getDeptNameList = (strDeptName) => axios.get('/orderClerkPrivilege/getDeptNameList', { params: { strDeptName } }); // 根据部门名称模糊获取部门列表
export const getSaleAreaList = (saleAreaName) => axios.get('/orderClerkPrivilege/getSaleAreaList', { params: { saleAreaName } }); // 根据区域名称模糊获取区域列表
export const getOrderPersonList = () => axios.get('/common/getOrdererInfo'); // 订单员信息
export const existenceOrderClerkList = () => axios.get('/orderClerkPrivilege/existenceOrderClerkList');// 获取已分配的订单员列表
export const getOrderClerkByUserCodeList = (userCode) => axios.get('/orderClerkPrivilege/getOrderClerkByUserCodeList', { params: { userCode } }); // 根据订单员编码获取权限列表
export const copyPrivilege = (params) => axios.post('/orderClerkPrivilege/copyPrivilege', params);

export const uploadReceiptSaveInfo = (params) => axios.post('/deliveryReceipt/addReceiptEnclosureList', params); // 上传回执单
export const selectRebateTypeList = (params) => axios.get('/useRebate/selectRebateTypeList', { params }); // 获取渠道返利类型列表

export const selectAgentAvailableRebate = (params) => axios.post('/useRebate/getOrderLifecycleAvailableRebate', params); // 据代理商信息查询代理商可用返利
export const getEditRebateUsedList = (params) => axios.get('/useRebate/getEditRebateUsedList', { params }); // 根据合同编码 查询使用过的返利列表
export const getRebateUsedList = (params) => axios.get('/useRebate/getRebateUsedList', { params });
export const agentUseRebate = (params) => axios.post('/useRebate/agentUseRebate', params); // 代理商使用返利(冻结
export const confirmUseRebate = (params) => axios.post('/useRebate/confirmUseRebate', params); // 返利确认、取消使用

export const getRebateSummaryAgentInfo = (params) => axios.get('/useRebate/getRebateSummaryAgentInfo', { params }); // 据账号获取渠道返利汇总信息
export const getContractDetailByContractNum = (contractNum) => axios.get('/contract/getContractDetailByContractNum', { params: { contractNum } }); // 根据合同编号商务助理获取合同详情
// 渠道部分发货
export const findPartialInvoiceInfoListByMasterContractId = (params) => axios.get('/partialInvoice/findPartialInvoiceInfoListByMasterContractId', { params }); // 根据合同id查询查询部分发货 已申请部分发货的 发货单 集合
export const findNotAppliedPartialShipmentList = (params) => axios.get('/partialInvoice/findNotAppliedPartialShipmentList', { params }); // 未申请分批发货信息
export const saveApplyPartialShipment = (params) => axios.post('/partialInvoice/saveApplyPartialShipment', params); // 保存审批部分发货订单信息(代理商申请分批发货)
export const revokeApply = (params) => axios.post('/partialInvoice/revokeApply', params); // 撤销分批发货申请（代理商撤销、订单员驳回）
export const agentRevokeApply = (params) => axios.post('/partialInvoice/agentRevokeApply', params); // 撤销分批发货申请（代理商撤销、订单员驳回）
export const rejectedPartialInvoice = (params) => axios.post('/partialInvoice/rejectedPartialInvoice', params); // 订单员驳回
export const findContractInfoForPartialInvoice = (params) => axios.post('/partialInvoice/findContractInfoForPartialInvoice', params);
export const appliedPartialInvoice = (params) => axios.post('/partialInvoice/appliedPartialInvoice', params); // 已申请分批发货列表
export const rejectAppliedPartialInvoice = (params) => axios.post('/partialInvoice/rejectAppliedPartialInvoice', params); // 驳回分批发货列表
export const partialInvoiceDetail = (params) => axios.get('/partialInvoice/partialInvoiceDetail', { params }); // 分批发货单详情
export const orderGetPartialInvoiceDetail = (params) => axios.get('/partialInvoice/orderGetPartialInvoiceDetail', { params }); // 分批发货单详情  -- new
export const getApproveLogByPartialId = (params) => axios.get('/approvePartial/getApproveLogByPartialId', { params }); // 历史审批意见
export const partialInvoiceProduct = (params) => axios.get('/partialInvoice/partialInvoiceProduct', { params }); // 获取产品列表
export const rejectAppliedPartialInvoiceSubmit = (id, params) => axios.post(`/partialInvoice/rejectAppliedPartialInvoiceSubmit/${id}`, params); // 驳回分批发货列表
export const partialInvoiceInvalid = (params) => axios.post(`/partialInvoice/partialInvoiceInvalid`, params); // 驳回分批发货列表

// 订单员部分发货
export const approvalPartialInvoice = (params) => axios.post('/partialInvoice/approvalPartialInvoice', params); // 订单员待审批已审批分批发货
export const approvedPartialInvoice = (params) => axios.post('/partialInvoice/approvedPartialInvoice', params); // 订单员已审批分批发货
export const orderApprovalPartialInvoice = (params) => axios.post('/partialInvoice/orderApprovalPartialInvoice', params); // 订单员审批分批发货单
export const getPartialShipmentFreight = (params) => axios.post('/partialInvoice/getPartialShipmentFreight', params); // 获取分批发货的运费
export const getAfterAgreedProduct = (params) => axios.post('/partialInvoice/getAfterAgreedProduct', params); // 交期大于今天的硬件和软件
export const getPartialWhiteList = (params) => axios.get('/partialInvoice/getPartialWhiteList', { params }); // 分批发货单详情
export const getOrderApprovalWorkFlow = (documentID) => axios.get('/orderInfo/getOrderApprovalWorkFlow', { params: { documentID } }); // 获取已办订单的流程状态信息列表
// export const selectExportPartialInvoice = () => axios.get('/partialInvoice/selectExportPartialInvoice'); ; // 分批发货单详情
export const undoPartialInvoice = (params) => axios.post('/partialInvoice/undoPartialInvoice', params); // 订单员撤销
export const getPartialOrderWithNoAssignData = (params) => axios.post('/partialInvoice/getPartialOrderWithNoAssignData', params); // 电汇单 查询
export const assignPartialInvoice = (params) => axios.post('/partialInvoice/assignPartialInvoice', params); // 分配接口
export const batchRejected = (params) => axios.post('/partialInvoice/batchRejected', params); // 批量驳回
export const batchThrough = (params) => axios.post('/partialInvoice/batchThrough', params); // 批量同意
export const getReceiptAttachmentByPartialShipmentNum = (params) => axios.get('/receiptAttachment/getReceiptAttachmentByPartialShipmentNum', { params }); // 分批发货单详情
// 电汇
export const abandonedTelegraphicTransfer = (id) => axios.get(`/telegraphicTransferInternation/abandonedTelegraphicTransfer/${id}`); // 查询电汇单明细
export const turnDownTelegraphicTransfer = (params) => axios.post(`/telegraphicTransferInternation/turnDownTelegraphicTransfer`, params); // 驳回
// 新增 电汇查询 商务
export const listTelegraphicTransferInternation = (params) => axios.post(`/telegraphicTransferInternation/listTelegraphicTransferInternation`, params); // 驳回
export const telegraphicTransferInternation = (id) => axios.get(`/telegraphicTransferInternation/${id}`); // 查询电汇单明细
// 黄黑名单
export const addYellowList = (params) => axios.post(`/creditYellowList/addYellowList`, params); //  新增信用管理黄名单
export const queryYellowList = (params) => axios.post(`/creditYellowList/queryYellowList`, params); //
export const operatingStatus = (params) => axios.get('/creditYellowList/operatingStatus', { params }); //
export const queryCreditYellowListDetail = (id) => axios.get(`/creditYellowList/queryCreditYellowListDetail/${id}`); //
export const updateCreditYellowList = (params) => axios.post(`/creditYellowList/updateCreditYellowList`, params); //
// 黑名单
export const selectCreditBlackList = (params) => axios.post(`/creditblacklist/selectCreditBlackList`, params); //  黑名单列表
export const getInfoByCustomerName = (params) => axios.get('/creditblacklist/getInfoByCustomerName', { params }); // 客户名称  带出 客户编码
export const insertSelective = (params) => axios.post(`/creditblacklist/insertSelective`, params); //  黑名单列表
export const selectByPrimaryKey = (params) => axios.get('/creditblacklist/selectByPrimaryKey', { params }); // 根据id获取一条黑名单列表数据
export const selectLockContractByCrmAccountName = (params) => axios.post(`/creditblacklist/selectLockContractByCrmAccountName`, params); //  根据客户名称查询锁定的合同列表
export const updateLockStatusByPrimaryKey = (params) => axios.post(`/creditblacklist/updateLockStatusByPrimaryKey`, params); // 批量设置勾选合同
export const updateByPrimaryKey = (params) => axios.post(`/creditblacklist/updateByPrimaryKey`, params); // 修改一条黑名单数据锁状态

// 办理新增接口
export const checkBlackLock = (params) => axios.get('/creditblacklist/checkBlackLock', { params }); // 断合同是否是黑名单状态(手动校验)
// export const checkBlackLock = (params) => axios.get('/creditblacklist/checkBlackLock', { params }); //
// 订单员 过单状态(非国际业务下单,国际分销下单)
export const selectById = (params) => axios.get('/autoOrderPassing/selectById', { params }); //
// 订单员 过单状态 (国际业务下单,国际分销下单)
export const intelSelectById = (params) => axios.get('/autoOrderPassing/intelSelectById', { params }); //
// 待付款
// 导入分配 下载模板
export const downTemplate = (params) => axios.get('/documentAllocation/downTemplate', { params }); //
export const getDocumentAllocationData = (params) => axios.post('/documentAllocation/getDocumentAllocationData', params, { headers: { 'Content-Type': 'multipart/form-data' } }); //
export const checkShippingData = (params) => axios.post('/export/checkShippingData', params, { headers: { 'Content-Type': 'multipart/form-data' } }); // 上传发货明细
export const saveShippingData = (params) => axios.post('/export/saveShippingData', params); // 上传发货明细
// 发布并付款
export const checkingSign = (params) => axios.get('/common/checkingSign', { params });
export const checkingDocumentAllocationData = (params) => axios.post(`/documentAllocation/checkingDocumentAllocationData`, params); // 修改一条黑名单数据锁状态
export const paymentRatioCheck = (params) => axios.get('/contract/paymentRatioCheck', { params });// 预付款比例校验
export const batchExportEnclosureList = (params) => axios.post(`/export/batchExportEnclosureList`, params); // 批量下载回执单
export const needAllocatePartialInvoice = (params) => axios.post(`/partialInvoice/needAllocatePartialInvoice`, params); // 分批发货 待付款
export const assignPartialInvoiceByListTelegraphic = (params) => axios.post(`/partialInvoice/assignPartialInvoiceByListTelegraphic`, params); // 按照电汇单确认分配
export const checkSplitAndFreightPayType = (params) => axios.get('/partialInvoice/checkSplitAndFreightPayType', { params });// 代理商在召回时，此类的情况要全部都召回，
// 助理
// 合同查询
export const selectContractForAssistant = (params) => axios.post('/assistant/selectContract', params);
export const changeContractSalesman = (params) => axios.post('/assistant/changeSalesman', params); // 修改外销人员
// 查看分批
export const selectPartialContractForAssistant = (params) => axios.post('/assistant/selectPartialContract', params);
// 查看齐套
export const selectDeliveryDateForAssistant = (params) => axios.post('/assistant/selectDeliveryDateForAssistant', params);
export const getNotAssignedPartialByContractNum = (params) => axios.get('/partialInvoice/getNotAssignedPartialByContractNum', { params });// 代理商在召回时，此类的情况要全部都召回，
export const createNewExtraPriceContract = (contractNum) => axios.get('/contract/createNewExtraPriceContract', { params: { contractNum } }); // 订单员 生成新合同（原合同基础上）
export const saveOrderExtraPriceContract = (params) => axios.post('/orderHandler/saveOrderExtraPriceContract', params);
export const agentGetPartialInvoiceDetail = (params) => axios.get('/partialInvoice/agentGetPartialInvoiceDetail', { params });
export const agentConfirmApplyPartialShipment = (params) => axios.post('/partialInvoice/agentConfirmApplyPartialShipment', params);// 总代办理

export const getContractProsAndSpecialPros = (contractId, isSon) => axios.get('/contractProduct/getContractProsAndSpecialPros', { params: { contractId, isSon } });

// 退换货 财务
export const financeList = (params) => axios.post('/finance/list', params);// 财务代办 已办列表
export const financeEditinfo = (params) => axios.post('/finance/edit-detail', params);// 财务办理基础数据
export const financeReject = (params) => axios.post('/finance/reject', params);// 财务 驳回
export const financeSubmit = (params) => axios.post('/finance/submit', params);// 财务提交
// 订单员
export const orderTodolist = (params) => axios.post('/order/todolist', params);// 财务代办列表
export const orderDonelist = (params) => axios.post('/order/donelist', params);// 财务已办列表
export const orderDetail = (params) => axios.post('/order/detail', params);// 财务办理
export const getOrderApprovalOpinion = (params) => axios.get('/order/getOrderApprovalOpinion', { params });// 退换货审批意见
export const getStorageByKeyWords = (params) => axios.get('/order/getStorageByKeyWords', { params });// 查询库位

// 退换货接口
// 代理商
// -------退换货列表
export const getListForAgent = (params) => axios.post('/returns/ag/ag-list', params);
// -------办理
export const getApproveData = (contractId, contractType, action) => axios.get('/returns/ag/ag-approve', { params: { contractId, contractType, action } });
// -------提交去盖章
export const submitToSignR = (params) => axios.post('/returns/ag/ag-submit-r', params);// 退货
export const submitToSignC = (params) => axios.post('/returns/ag/ag-submit-c', params);// 换货
// -------盖章提交去付款
export const submitToPay = (params) => axios.post('/returns/ag/ag-toPay', params);
// -------召回
export const reCall = (params) => axios.post('/returns/ag/ag-recall', params);
// -------退款银行信息
export const getBankInfoForReturns = (companyName) => axios.get('/returns/ag/ag-bank', { params: { companyName } });
// -------删除合同附件
export const deleteReturnsAttachment = (params) => axios.post('/returns/ag/ag-deleteReturnsAttachment', params);
// -------获取合同附件列表
export const getReturnsContractAttachment = (contractId, fileType) => axios.get('/returns/ag/ag-getAttachment', { params: { contractId, fileType } });
// -------打印
export const printContractPdf = (contractId) => axios.get('/returns/ag/ag-printContractPdf', { params: { contractId } });
// --------保存上传的附件信息
export const saveReturnsAttachment = (params) => axios.post('/returns/ag/ag-saveReturnsAttachment', params); // 合同附件上传成功后保存信息到数据库
// ---------去签章
export const doSignForReturns = (contractId) => axios.get('/es/doSign', { params: { contractId } });
// ---------分配基础信息
export const getContractDetailAllInfoById = (contractId) => axios.get('/returns/ag/getContractDetailAllInfoById', { params: { contractId } });
// ---------国际分配基础信息
export const getInterContractDetailAllInfoById = (contractId) => axios.get('/overseasExOrder/getContractDetailAllInfoById', { params: { contractId } });
// 代理商退换货合同确认分配
export const contractToAssignInfoListTransfer = (params) => axios.post('/assign/dealtContractToAssignInfoListTransfer', params);
//  获取分配结果接口
export const getAssignInfo = (params) => axios.post('/assign/getAssignInfo', params);
//  确认无误接口
export const saveDealtContractAssign = (params) => axios.post('/assign/saveDealtContractAssign', params);
// ---------去签章
export const getAssignLogByContractId = (contractId) => axios.get('/assign/getAssignLogByContractId', { params: { contractId } });
// 合同办理前检查
export const checkSubmit = (params) => axios.get('/order/check/submit', { params }); //
// 订单员 退货 提交
export const rSubmit = (params) => axios.post('/order/r/submit', params); //
// 订单员 换货 提交
export const cSubmit = (params) => axios.post('/order/c/submit', params); //
// 换货订单出口合规检测
export const detectExportCompliance = (params) => axios.post('/order/compliance/detect', params);
// 创建出口合规审查单
export const createExportComplianceReview = (params) => axios.post('/order/compliance/review/create', params);
// 订单员 驳回代理商
export const orderCancel = (params) => axios.post('/order/cancel', params); //
// 代理商 序列号列表
export const getDbContractDelivery = (params) => axios.post('/data/getDbContractDelivery', params);//
// 代理商 序列号和产品对应关系提交
export const saveProductSerialNum = (params) => axios.post('/serial/saveProductSerialNum', params);//

// 修改下载部分
export const exportAgentOrderInfo = (createBeginTime, createEndTime) => axios.get('/export/exportAgentOrderInfo', { params: { createBeginTime, createEndTime }, responseType: 'blob' });
export const downloadImport = () => axios.get('/documentAllocation/downTemplate', { responseType: 'blob' });// 下载导入模板
export const downShippingTemplate = () => axios.get('/documentAllocation/downShippingTemplate', { responseType: 'blob' });// 下载导入模板
// 导出云桌面产品合同
export const exportFinancialSpecialProductInfo = (createBeginTime, createEndTime) => axios.get('/export/exportFinancialSpecialProductInfo', { params: { createBeginTime, createEndTime }, responseType: 'blob' });
// 发货明细
export const getDeliveryReceiptByProductList = (startTime, endTime) => axios.get('/export/getDeliveryReceiptByProductList', { params: { startTime, endTime }, responseType: 'blob' });
export const getExportAgentAgreedDeliveryDate = () => axios.get('/export/getExportAgentAgreedDeliveryDate', { responseType: 'blob' });// 下载导入模
// 保存查看地址信息
export const updateContractReceiptAddress = (params) => axios.post('/contract/updateContractReceiptAddress', params);
// 新-保存查看地址
export const updateContractReceiptAddressByLine = (params) => axios.post('/contract/updateContractReceiptAddressByLine', params);

export const exportAllocationDetailRecord = (startTime, endTime, projectName, contractNum) => axios.get('/export/exportAllocationDetailRecord', { params: { startTime, endTime, projectName, contractNum }, responseType: 'blob' });

// 更新多地址
export const updateMultiaddress = (params) => axios.get('/contract/updateMultiaddress', { params });
// 优化授权邮箱
export const getStaffByStaffNo = (params) => axios.get('/intelBusinessDelivers/getStaffByStaffNo', { params });

// 删除价外费用合同
export const deleteNewExtraPriceContract = (params) => axios.get('/contract/deleteNewExtraPriceContract', { params });
// 召回价外费用合同
export const recallNewExtraPriceContract = (params) => axios.get('/contract/recallNewExtraPriceContract', { params });
// 上传对账单
export const createCreditReconcliation = (params) => axios.post('/creditReconcliation/createCreditReconcliation', params);
// 查询当前月份 有效的对账单列表
export const selectCurrDateAvaliable = () => axios.get('/creditReconcliation/selectCurrDateAvaliable');
// 商务-合同查询-对账单查询
export const selectByCondition = (params) => axios.post('/creditReconcliation/selectByCondition', params);
// 获取对账单信息
export const getReconciliationInfo = (params) => axios.get('/contract/getReconciliationInfo', { params });
// 删除对账单信息
export const deleteAttachmentById = (params) => axios.get('/creditReconcilationAttachment/deleteAttachmentById', { params });
// 获取对账单签章调用
export const creditReconElectronicSignature = () => axios.get('/signature/creditReconElectronicSignature');
// 获取对账单打印接口
export const printReconciliationPDF = () => axios.get('/contract/printReconciliationPDF');
// 获取 商务对账单附件数据
export const selectAttachmentByAccountStatementId = (params) => axios.get('/creditReconcilationAttachment/selectAttachmentByAccountStatementId', { params });
// 查询物流列表
export const getInterDeliveryDetailsList = (strContractCode) => axios.get('/contract/getInterDeliveryDetailsList', { params: { strContractCode } }); //  查询物流列表
// 业财一体化
// 下拉基础数据
export const getDictData = (params) => axios.post('/orderCommon/getDictData', params);
// 资金认领/待分配 已分配
export const distributedOrder = (params) => axios.post('/orderFundsClaim/distributedOrder', params);
// 资金查询  修改客户
export const modifyCustomerName = (params) => axios.post('/telApproval/modifyCustomerName', params);
// 编辑回显/办理回显
export const handleEcho = (params) => axios.get('/telApproval/handleEcho', { params });
// 资金查询  编辑客户
export const telApprovalEdit = (params) => axios.post('/telApproval/edit', params);
// 待审批资金管理列表查询
export const toAuditList = (params) => axios.post('/moneyManagement/toAuditList', params);
// 已审核的列表查询
export const theApproved = (params) => axios.post('/moneyManagement/theApproved', params);
// 查询电汇单列表
export const selectAssignInfoByUserCodeOrContractNum = (params) => axios.post('/contractAssign/selectAssignInfoByUserCodeOrContractNum', params); // 根据用户标识查询电汇列表2
// 主管-财务 同意、驳回单据
export const handleApproval = (params) => axios.post('/telApproval/handleApproval', params);
// 确认分配
export const orderAssignDealtContractToAssignInfoListTransfer = (params) => axios.post('/orderAssign/dealtContractToAssignInfoListTransfer', params);
// 更新系统分配功能
export const updateSystemAssignFunction = () => axios.get('/TelegraphicTransfer/updateSystemAssignFunction');
// 批量更新电汇单摘要
export const batchUpdateTelSummary = (params) => axios.post('/TelegraphicTransfer/batchUpdateTelSummary', params);
export const getContractInfoById = (id) => axios.get('/contract/getContractInfoById', { params: { id } }); //  查询订单类型
/**
 * 开票管理
 */
// 商务分页查询已申请发票列表
export const listInvoice = (params) => axios.post('/advance/process/pageQueryAppliedInvoice', params);
// 商务分配
export const selectAssignInfoBusinessAndContractNum = (params) => axios.post('/contractAssign/selectAssignInfoBusinessAndContractNum', params);

// 分配明细查看
export const distributionDetailView = (id) => axios.get('/telFundManagementApproval/distributionDetailView', { params: { id } }); //  查询物流列表
// 分配明细查看-退换货
export const distributionDetailViewThh = (id) => axios.get('/assign/distributionDetailView', { params: { id } });
// 根据合同号查询发货单信息
export const getContractDelivery = (params) => axios.get('/telFundManagementApproval/getContractDelivery', { params });
// 提交撤销申请（分配记录-来款单）
export const undoDistributionAgree = (params) => axios.post('/telFundManagementApproval/undoDistributionAgree', params);
// 提交撤销申请（换货合同）
export const assignUndoDistributionAgree = (params) => axios.post('/assign/undoDistributionAgree', params);
// 废弃分配记录-查询待审核列表
export const selectApproval = (params) => axios.post('/telFundManagementApproval/selectApproval', params);
// 废弃分配记录-查询待审核列表-退换货
export const selectApprovalThh = (params) => axios.post('/assign/selectApproval', params);
// 废弃分配记录-查询已审核列表
export const checkedDistributionRecords = (params) => axios.post('/telFundManagementApproval/checkedDistributionRecords', params);
// 废弃分配记录-查询已审核列表-退换货
export const checkedDistributionRecordsThh = (params) => axios.post('/assign/checkedDistributionRecords', params);
// 废弃分配记录确认、驳回
export const confirmApproval = (params) => axios.post('/telFundManagementApproval/confirmApproval', params);
// 废弃分配记录确认、驳回-退换货
export const confirmApprovalThh = (params) => axios.post('/assign/confirmApproval', params);
// 废弃电汇单 待审核列表
export const abandonTelewatingApproval = (params) => axios.post('/telFundManagementApproval/abandonTelewatingApproval', params);
// 废弃电汇单 已审核列表
export const checkedList = (params) => axios.post('/telFundManagementApproval/checkedList', params);
// 验证erp是否已发货
export const isShipped = (contractNum) => axios.get('/isShipped', { params: { contractNum } });
// 验证erp是否已发货
export const checkShipped = (telegraphicTransferNum, rebuild) => axios.get('/checkShipped', { params: { telegraphicTransferNum, rebuild } });
// 来款单查看
export const ToInvoiceView = (id) => axios.get('/telFundManagementApproval/ToInvoiceView', { params: { id } });
// 电汇单废弃办理接口（确认废弃、驳回）
export const confirmTransfer = (params) => axios.post('/telFundManagementApproval/confirmTransfer', params);
// 来款单查看
export const scrapReceipt = (telId) => axios.get('/scrapReceipt', { params: { telId } });
// 资金认领-分配明细查看
export const viewingAllocationDetails = (id) => axios.get('/orderFundsClaim/viewingAllocationDetails', { params: { id } });

//  查询物流列表
export const distributionView = (id) => axios.get('/telFundManagementApproval/distributionView', { params: { id } });
//  查询物流列表
export const distributionViewTHH = (id) => axios.get('/assign/distributionView', { params: { id } });
// 退换货合同查询列表
export const getReOrderList = (params) => axios.post('/assistant/getReturnsContract', params);
// 退换货合同查询列表-销售
export const getReOrderListSale = (params) => axios.post('/assistant/getReturnsContractBySales', params);
// 获取附件
export const agGetAttachment = (params) => axios.get('/returns/ag/ag-getAttachment', { params });
// 获取签章地址
export const assistantDoSign = (params) => axios.get('/assistant/doSign', { params });
// 点击分配按钮校验是否可分配
export const checkDealtContractAssign = (params) => axios.get('/assign/checkDealtContractAssign', { params });
// 分配查看页面
export const getAssignInfoView = (params) => axios.get('/assign/getAssignInfoView', { params });
// 取消分配
export const cancelDealtContractAssign = (params) => axios.get('/assign/cancelDealtContractAssign', { params });

// 合同查询提前开票

// 获取未申请开票的产品集合
export const getUnInvoiceProducts = (contractNum) =>
  axios.get('/advance/getUnInvoiceProducts', {
    params: { contractNum }
  });

// 申请提前开票
export const applyAdvanceInvoice = (params) =>
  axios.post('/advance/applyAdvanceInvoice', params);

// 提前开票附件导入
export const uploadAdvance = (params) =>
  axios.post('/advance/uploadAdvance', params,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

// 商务导出商品明细
export const exportProductInfo = (params) =>
  axios.post('/advance/exportProductInfo', params, {
    responseType: 'blob'
  });

// 获取开票客户的银行信息
export const getCustomerBankInfo = (params) =>
  axios.get('/advance/getCustomerBankInfo', {
    params: params
  });

// 提交开票申请
export const submitApply = (params) =>
  axios.post('/advance/submitApply', params);

// 商务分页查询已申请发票列表
export const pageQueryAppliedInvoice = (params) =>
  axios.post('/advance/pageQueryAppliedInvoice', params);

// 查看开票明细
export const getProcessinfo = (params) =>
  axios.post('/advance/process/info', params);

// 导出开票信息
export const exportInvoicedInfo = (params) =>
  axios.post('/advance/exportInvoicedInfo', params, {
    responseType: 'blob'
  });

// 召回
export const processRecall = (params) =>
  axios.post('/advance/processRecall', params);

// 编辑
export const editApply = (params) =>
  axios.post('/advance/editApply', params);

// 废弃
export const deleteApply = (params) =>
  axios.post('/advance/deleteApply', params);

// 开票角色接口

// 管理分页查询发票的审批列表
export const getPageQueryAppliedInvoice = (params) =>
  axios.post('/advance/process/pageQueryAppliedInvoice', params);

// 流程审批
export const processApproval = (params) =>
  axios.post('/advance/process/approval', params);

// 导出开票信息（订单员）
export const processExportInvoicedInfo = (params) =>
  axios.post('/advance/process/exportInvoicedInfo', params, {
    responseType: 'blob'
  });

// 导出冲销开票信息（订单员）
export const exportInvoicedProduct = (params) =>
  axios.post('/advance/process/exportInvoicedProduct', params, {
    responseType: 'blob'
  });

// 下载开票附件
export const downloadFile = (params) =>
  axios.get('/advance/process/downloadFile', {
    params: params
  });

// 财务填写
export const financialEdit = (params) =>
  axios.post('/advance/process/financialEdit', params);

// 导入金税发票
export const importTaxInvoice = (params) => axios.post('/advance/process/importTaxInvoice', params);

// 导入快递单号
export const importExpressBll = (params) => axios.post('/advance/process/importExpressBll', params);

// 校验导入金税发票
export const importTaxInvoiceCheck = (params) => axios.post('/advance/process/importTaxInvoiceCheck', params, { headers: { 'Content-Type': 'multipart/form-data' } });

// 校验导入快递单号
export const importExpressBllCheck = (params) => axios.post('/advance/process/importExpressBllCheck', params, { headers: { 'Content-Type': 'multipart/form-data' } });

// 申请分批发货列表（商务）
export const selectPartialInvoice = (params) =>
  axios.post('/partialInvoice/selectPartialInvoice', params);

// 导出申请分批发货列表（商务）
export const downloadPartialInvoice = (params) =>
  axios.post('/partialInvoice/downloadPartialInvoice', params, {
    responseType: 'blob'
  });

// 待付款发货单
export const selectBusinessUnAssignList = (params) =>
  axios.post('/partialInvoice/selectBusinessUnAssignList', params);

// 商务点击编辑再提交接口
export const businessConfirmApplyPartialShipment = (params) =>
  axios.post('/partialInvoice/businessConfirmApplyPartialShipment', params);

// 分页查询打印列表
export const pageQueryMarkInfo = (params) =>
  axios.post('/markInfo/pageQueryMarkInfo', params);

// 分页查询可用的唛头模板
export const getEnableMarkTemplate = (params) =>
  axios.post('/markTemplate/getEnableMarkTemplate', params);

// 制作唛头模板+数据回显
export const makeMarksViewTemplate = (params) =>
  axios.get('/markTemplate/makeMarksViewTemplate', {
    params: params
  });

// 制作唛头-保存
export const markMakeMark = (params) =>
  axios.post('/mark/makeMark', params);

// 唛头查看
export const previewMarkInfo = (params) =>
  axios.get('/markInfo/previewMarkInfo', {
    params: params
  });

// 唛头打印
export const printMarkInfo = (params) =>
  axios.get('/markInfo/printMarkInfo', {
    params: params
  });

// 唛头标记为已打印
export const updatePrintOrNot = (params) =>
  axios.post('/markInfo/updatePrintOrNot', null, {
    params: params
  });

// 查看唛头的详情数据
export const getMarkInfoData = (params) =>
  axios.get('/mark/getMarkInfoData', {
    params: params
  });

// 编辑唛头信息
export const markEditMark = (params) =>
  axios.post('/mark/editMark', params);

// 唛头制作：采购单PDF解析（预留口）
export const parseMarkPurchaseOrderFile = (params) =>
  axios.post('/mark/ai-recognition-analysis', params);

// 唛头制作：基础数据Excel解析（预留口）
export const parseMarkBaseDataFile = (params) =>
  axios.post('/mark/upload-file-comparison', params, { headers: { 'Content-Type': 'multipart/form-data' } });
/**
 * @desc 商务权限管理
 */
// 根据名称获取部门信息列表
export const getDeptInfoList = (params) => axios.get('/businessRelationship/getDeptInfoList', { params });

// 根据名称获取区域信息列表
export const getAreaInfoList = (params) => axios.get('/businessRelationship/getAreaInfoList', { params });

// 查询商务助理权限列表
export const getBusinessShipList = (params) => axios.post('/businessRelationship/getBusinessShipList', params);

// 添加/修改商务助理权限
export const saveBusinessShip = (params) => axios.post('/businessRelationship/saveBusinessShip', params);

// 删除商务助理权限
export const delBusinessShip = (params) => axios.get('/businessRelationship/delBusinessShip', { params });

// 复制商务权限
export const copyBusinessShip = (params) => axios.post('/businessRelationship/copyBusinessShip', params);
// 通过原合同查询退换货数据
export const getContractNumByOldNum = (params) =>
  axios.get('/base/getContractNumByOldNum', {
    params: params
  });

// 通过换货合同查询退换货数据
export const getContractNumByNewNum = (params) =>
  axios.get('/base/getContractNumByNewNum', {
    params: params
  });

// 换货合同合同产品明细
export const getChangeContractInfo = (params) =>
  axios.get('/returns/ag/getChangeContractInfo', {
    params: params
  });

// 根据原合同编号查询关联换货合同产品明细
export const getChangeContractInfoByOldContractNum = (oldContractNum) =>
  axios.get('/returns/ag/getChangeContractInfoByOldContractNum', {
    params: { oldContractNum }
  });

// 获取换货合同约定交付日期明细
export const agGetAgreedDeliveryDate = (params) =>
  axios.get('/returns/ag/getAgreedDeliveryDate', {
    params
  });

// 生成合同启动函
export const printInitiationLetterPdf = (params) =>
  axios.get('/contract/printInitiationLetterPdf', {
    params: params
  });

// 启动函去签章
export const initiationLetterElectronicSignature = (params) =>
  axios.get('/signature/initiationLetterElectronicSignature', {
    params: params
  });

// 启动函去签章
export const getChangeGoodsAllowUseRebate = (params) =>
  axios.get('/base/getChangeContractRebateInfo', {
    params: params
  });

/**
 * @desc 加载所有特殊票据需求
*/
export const listSpecialTicketsRequirements = () => axios.get('/common/listSpecialTicketsRequirements');

/**
 * @desc 代理商/商务 合同详情页面 保存特殊开票需求接口
*/
export const saveSpecialTicketRequirements = (params) => axios.post('/contract/saveSpecialTicketRequirements', params);

/**
* @desc 对账单导出接口
*/
export const exportBusinessEmailNotificationStatementDetails = (params) => axios.post('/contract/exportBusinessEmailNotificationStatementDetails', params, { responseType: 'blob' });

/**
* @desc 合同分配分页查询电汇单列表,根据合同编号过滤业务实体
*/
export const selectAssignInfoByContractNum = (params) => axios.post('/contractAssign/selectAssignInfoByContractNum', params);

/**
* @desc 计算产品行的实际结算金额
*/
export const calculateProductSettlementAmount = (params) => axios.post('/contractProduct/calculateProductSettlementAmount', params);
/** 查询产品供应SLA对应的客期可选范围，EBG试点场景用于计算产品行默认客期和上下限。 */
export const productOrdersPreparationTime = (params) => axios.post('/contractProduct/productOrdersPreparationTime', params);

/**
* @desc 切换用户
*/
export const changUser = (params) => axios.get('/user/changUser', { params });

/**
* @desc 冻结或解冻电汇单
*/
export const updateTransferFreeze = (params) => axios.put(`/TelegraphicTransfer/updateTransferFreeze?id=${params.id}&freezeStatus=${params.freezeStatus}`);

/**
* @desc 从合同地址变更记录表中查询最新修改的地址，没有则取默认地址
*/
export const queryRecentlyUpdatedAddress = (params) => axios.post('/receiptAddressInfo/queryRecentlyUpdatedAddress', params);

/**
* @desc 数仓查询订单信息，包含地址和产品集合
*/
export const queryOrderInfoFromDsData = (params) => axios.get('/contract/queryOrderInfoFromDsData', { params });

/**
* @desc 验证当前退货合同对应的原合同在退货合同抛单计算实际退款金额后是否进行了电汇
* @param {string} contractId 合同id
*/
export const checkContractAbandonAssign = (params) => axios.get('/assign/checkContractAbandonAssign', { params });

/**
* @desc 保存部分发货订单信息(代理商申请分批发货)
*/
export const strategySaveApplyPartialShipment = (params) => axios.post('/strategyShipment/saveApplyPartialShipment', params);

/**
 * @desc 数仓：查询发货明细
 */
export const queryShippingInfoFromDsData = (params) => axios.get('/contract/queryShippingInfoFromDsData', { params });
// 查询国际退换货合同
export const overseasExOrderTodolist = (params) => axios.post('/overseasExOrder/todolist', params);

// 查询国际退换货合同详情
export const getDetailData = (params) => axios.post('/overseasExOrder/getDetailData', params);

// 国际退换货退货提交
export const returnSubmit = (params) => axios.post('/overseasExOrder/returnSubmit', params);

// 国际退换货换货提交
export const changeSubmit = (params) => axios.post('/overseasExOrder/changeSubmit', params);

// 币种和仓库
export const dictgetDictData = (params) => axios.get('/dict/getDictData', { params });

// 区域商务专员
export const commongetAssistantInfo = (params) => axios.get('/common/getAssistantInfo', { params });

// 通过合同号获取附件
export const overseasExOrderAttachment = (params) => axios.get('/overseasExOrder/attachment', { params });

// 国际退换货合同附件上传成功后保存信息到数据库
export const uploadFile = (params) => axios.post('/overseasExOrder/uploadFile', params);

// 查询国际已办退货详情
export const getDoneReturnDetailData = (params) => axios.get('/overseasExOrder/getDoneReturnDetailData', { params });

// 查询国际已办换货详情
export const getDoneReplacementDetailData = (params) => axios.get('/overseasExOrder/getDoneReplacementDetailData', { params });

// 查询国际已办换货详情
export const getOverseasExContractNumByNewNum = (params) => axios.get('/overseasExOrder/getOverseasExContractNumByNewNum', { params });

// CSP：获取保卡卡号信息
export const queryCardNumberInformation = (params) => axios.post('/contract/queryCardNumberInformation', params);

// 查询电票邮箱
export const getInvoiceEmailMailList = (params) => axios.get('/contract/getInvoiceEmailMailList', { params });

// 订单详情 订单全流程看板 4 条线
// 预计/实际达成 2条时间线
export const getExpectedAndActualAchieveProcess = (params) => axios.post('/dashboard/getExpectedAndActualAchieveProcess', params);
// 付款状态 时间线
export const getPaymentStatusProcess = (params) => axios.post('/dashboard/getPaymentStatusProcess', params);
// 开票状态 时间线
export const getInvoicetStatusProcess = (params) => axios.post('/dashboard/getInvoicetStatusProcess', params);

// 订单看板
// 整体看板
export const getOrderEntiretyBoard = (params) => axios.post('/dashboard/getInvoicetStatusProcess', params);
// 整体看板  -- 销售信息
export const getBoardSalesList = (params) => axios.post('/dashboard/analysis/sales', params);
//  整体看板  -- 销售信息  --- 导出明细
export const getBoardSalesListDownload = (params) => axios.post('/dashboard/analysis/export-sales', params, { responseType: 'blob' }); // 下载导入模板
// 整体看板  -- 订单齐套提货分析
export const getBoardCompletionList = (params) => axios.post('/dashboard/analysis/order-completion', params);
// 整体看板  -- 订单齐套提货分析（明细）列表
export const getBoardCompletionListDetails = (params) => axios.post('/dashboard/analysis/order-completion-details', params);
//  整体看板  -- 订单齐套提货分析  --- 导出明细
export const getBoardcompletionListDownload = (params) => axios.post('/dashboard/analysis/export-order-completion', params, { responseType: 'blob' }); // 下载导入模板
// 整体看板  -- 订单开票分析
export const getBoardInvoiceList = (params) => axios.post('/dashboard/analysis/order-invoice', params);
// 整体看板  -- 订单开票分析 （明细）列表
export const getBoardInvoiceListDetails = (params) => axios.post('/dashboard/analysis/order-invoice-details', params);
//  整体看板 -- 订单开票分析  --- 导出明细
export const getBoardInvoiceListDownload = (params) => axios.post('/dashboard/analysis/export-order-invoice', params, { responseType: 'blob' }); // 下载导入模板
// 整体看板  -- 订单发货
export const getBoardShipmentList = (params) => axios.post('/dashboard/analysis/order-shippinglogistics-receipt', params);
//  整体看板 -- 订单发货  --- 导出明细
export const getBoardShipmentListDownload = (params) => axios.post('/dashboard/analysis/export-order-shippinglogistics-receipt', params, { responseType: 'blob' }); // 下载导入模板
// 整体看板  -- 订单付款情况
export const getBoardOrderPaymentStatus = (params) => axios.post('/dashboard/analysis/accounts-pay-status', params);
//  整体看板 -- 订单付款情况  --- 导出明细
export const getBoardOrderPaymentStatusDownload = (params) => axios.post('/dashboard/analysis/export-accounts-pay-status', params, { responseType: 'blob' }); // 下载导入模板

// 异常看板
export const getOrderErrorBoard = (params) => axios.post('/dashboard/getInvoicetStatusProcess', params);
// 2025-07-08 09:55:02
// 异常看板 订单交期异常单数分析(未发货订单)
export const getOrderLeadTimeErrorBoard = (params) => axios.post('/dashboard/analysis/abnormal-order-delivery', params);
// 异常看板 订单交期异常单数分析 列表
export const getOrderLeadTimeErrorBoardList = (params) => axios.post('/dashboard/analysis/abnormal-order-delivery-details', params);
// 异常看板 订单交期异常单数分析 导出明细
export const getOrderLeadTimeErrorBoardsDownload = (params) => axios.post('/dashboard/analysis/export-abnormal-order-delivery', params, { responseType: 'blob' }); // 下载导入模板

// 2025-07-08 10:01:09
// 异常看板 发货单抛转失败分析
export const getOrderFailedHandoffErrorBoard = (params) => axios.post('/dashboard/analysis/failed-handoff', params);
// 异常看板 发货单抛转失败分析 列表
export const getOrderFailedHandoffErrorBoardList = (params) => axios.post('/dashboard/analysis/failed-handoff-details', params);
// 异常看板 发货单抛转失败分析 导出明细
export const getOrderFailedHandoffErrorBoardDownload = (params) => axios.post('/dashboard/analysis/export-failed-handoff', params, { responseType: 'blob' }); // 下载导入模板

// 2025-07-08 13:41:52
// 异常看板 渠道待办异常在途订单分析
export const getOrderChannelsToDoErrorBoard = (params) => axios.post('/dashboard/analysis/channel-abnormal-order', params);
// 异常看板 渠道待办异常在途订单分析 列表
export const getOrderChannelsToDoErrorBoardList = (params) => axios.post('/dashboard/analysis/channel-abnormal-order-details', params);
// 异常看板 渠道待办异常在途订单分析 导出明细
export const getOrderChannelsToDoErrorBoardDownload = (params) => axios.post('/dashboard/analysis/export-channel-abnormal-order', params, { responseType: 'blob' }); // 下载导入模板

// 2025-07-09 09:26:26
// 异常看板 齐套现款提货罚息 PenaltyInterestForPickUp
export const getOrderPenaltyInterestForPickUpErrorBoard = (params) => axios.post('/dashboard/analysis/penalty-interest', params);

// 异常看板 齐套现款提货罚息 列表
export const getOrderPenaltyInterestForPickUpErrorBoardList = (params) => axios.post('/dashboard/analysis/penalty-interest-details', params);
// 异常看板 齐套现款提货罚息 导出明细
export const getOrderPenaltyInterestForPickUpErrorBoardDownload = (params) => axios.post('/dashboard/analysis/export-penalty-interest', params, { responseType: 'blob' }); // 下载导入模板

// 导出明细
export const getOrderEntiretyBoardDownload = () => axios.get('/documentAllocation/downTemplate', { responseType: 'blob' });// 下载导入模板

// PO-获取回执单号
export const receiptAttachmentCreateNewReceiptNumber = () => axios.get('/receiptAttachment/createNewReceiptNumber?type=RJHZ');
// PO-获取申请页面地址分组
export const receiptAttachmentGetAddressGroupList = (params) => axios.post('/partialInvoice/partialInoiceByAddress', params);
// PO-校验地址信息
export const receiptAttachmentCheckAddressInfo = (params) => axios.post('/partialInvoice/checkSameAddressTransportAndCarrier', params);
// PO-提交分组信息
export const savePartialShipment = (params) => axios.post('/partialInvoice/savePartialShipment', params);
// PO-获取编辑信息
export const receiptAttachmentGetEditInfo = (id) => axios.get('/partialInvoice/agentGetPartialInvoiceDetail?id=' + id);
// PO-获取详情
export const receiptAttachmentGetDetailInfo = (id) => axios.get('/partialInvoice/partialInvoiceDetail?id=' + id);

export const confirmWireTransferAllocation = (params) => axios.post('/orderFundsClaim/confirmWireTransferAssign', params);

export const createInvoiceNotice = () => Promise.resolve({ data: { status: '200', data: true } });

/**
 * @desc 已创建结算单分页列表查询
 * @param {Object} params 查询参数
 */
export const getCreatedSettlementList = (params = {}) => {
  return axios.post('/settlement/createdList', params);
};

/**
 * @desc 单张结算单详情查询
 * @param {Object} params { id, settlementNo, contractNum }
 */
export const getSettlementDetail = (params = {}) => {
  return axios.post('/settlement/detail', params);
};

export const getCreditTransferConfirmedList = (params = {}) => {
  const pageIndex = params.pageIndex || 1;
  const pageSize = params.pageSize || 10;
  const filterText = (value) => String(value || '').trim();
  let list = creditTransferConfirmedList.filter((item) => {
    const customerPoCode = filterText(params.customerPoCode);
    const cesContractNo = filterText(params.cesContractNo);
    const customerName = filterText(params.customerName);
    const projectName = filterText(params.projectName);
    const milestone = filterText(params.milestone);
    return (!customerPoCode || String(item.customerPoCode || '').indexOf(customerPoCode) > -1) &&
      (!cesContractNo || String(item.cesContractNo || '').indexOf(cesContractNo) > -1) &&
      (!customerName || String(item.customerName || '').indexOf(customerName) > -1) &&
      (!projectName || String(item.projectName || '').indexOf(projectName) > -1) &&
      (!milestone || String(item.milestone || '').indexOf(milestone) > -1);
  });
  const total = list.length;
  const start = (pageIndex - 1) * pageSize;
  list = list.slice(start, start + pageSize);
  return Promise.resolve({ data: { status: '200', data: { list: JSON.parse(JSON.stringify(list)), total } } });
};

export const getCreditTransferPendingList = (params = {}) => {
  return axios.post('/notReceipt/pendingList', params);
};

export const submitAcceptanceNotReceipt = (params = {}) => {
  return axios.post('/notReceipt/submit', params);
};

export const getAcceptanceReceiptPoList = (params = {}) => {
  return axios.post('/receipt/getIncomeConfirmedPoList', params);
};

export const getAcceptanceReceiptPoDetail = (params = {}) => {
  return axios.post('/receipt/getIncomeConfirmedPoDetail', params);
};

export const getAcceptanceReceiptArDetail = (params = {}) => {
  return axios.post('/receipt/getIncomeConfirmedArDetail', params);
};

export const saveAcceptanceReceiptArAttachment = (params = {}) => {
  return axios.post('/receipt/saveIncomeConfirmedArAttachment', params);
};

export const submitAcceptance = (params = {}) => axios.post('/receipt/submitAcceptance', params, { skipGlobalError: true });

export const getInvoiceNoticeCreatedList = (params = {}) => {
  const pageIndex = params.pageIndex || 1;
  const pageSize = params.pageSize || 10;
  const invoiceNoticeNo = normalizeText(params.invoiceNoticeNo);
  const customerName = normalizeText(params.customerName);
  const cesContractNo = normalizeText(params.cesContractNo);
  const status = normalizeText(params.status);
  let list = invoiceNoticeCreatedList.filter((item) => {
    return (!invoiceNoticeNo || String(item.invoiceNoticeNo || '').indexOf(invoiceNoticeNo) > -1) &&
      (!customerName || String(item.customerName || '').indexOf(customerName) > -1) &&
      (!cesContractNo || String(item.cesContractNo || '').indexOf(cesContractNo) > -1) &&
      (!status || String(item.status || '').indexOf(status) > -1);
  });
  const total = list.length;
  const start = (pageIndex - 1) * pageSize;
  list = list.slice(start, start + pageSize);
  return Promise.resolve({ data: { status: '200', data: { list: JSON.parse(JSON.stringify(list)), total } } });
};

export const getInvoiceNoticePendingList = (params = {}) => {
  const pageIndex = params.pageIndex || 1;
  const pageSize = params.pageSize || 10;
  const customerPoCode = normalizeText(params.customerPoCode);
  const cesContractNo = normalizeText(params.cesContractNo);
  const customerName = normalizeText(params.customerName);
  const projectName = normalizeText(params.projectName);
  let list = invoiceNoticePendingList.filter((item) => {
    return (!customerPoCode || String(item.customerPoCode || '').indexOf(customerPoCode) > -1) &&
      (!cesContractNo || String(item.cesContractNo || '').indexOf(cesContractNo) > -1) &&
      (!customerName || String(item.customerName || '').indexOf(customerName) > -1) &&
      (!projectName || String(item.projectName || '').indexOf(projectName) > -1);
  });
  const total = list.length;
  const start = (pageIndex - 1) * pageSize;
  list = list.slice(start, start + pageSize);
  return Promise.resolve({ data: { status: '200', data: { list: JSON.parse(JSON.stringify(list)), total } } });
};

export const getAcceptanceReceiptList = (params = {}) => {
  return axios.post('/receipt/list', params);
};

export const getPendingSettlementQueryList = (params = {}) => {
  return axios.post('/settlement/pendingList', params);
};

/**
 * @desc 创建结算单（部分勾选/整单/跨PO）
 * @param {Object} params { createType: 'WHOLE'|'PARTIAL'|'CROSS_PO', customerName, selectedReceivables: [{ receivableNo }] }
 */
export const createSettlement = (params = {}) => {
  return axios.post('/settlement/create', params);
};

export const getWireTransferAllocationSlip = (telegraphicTransferNum) => axios.post('/orderFundsClaim/getWireTransferAssignSlip', { telegraphicTransferNum });

export const getWireTransferSettlementAllocationList = (params = {}) => {
  return axios.post('/orderFundsClaim/getSettlementAssignList', {
    telegraphicTransferNum: params.telegraphicTransferNum,
    customerPurchaseOrderNo: params.customerPoCode,
    pageIndex: params.pageIndex || 1,
    pageSize: params.pageSize || 10
  });
};

// 渠道多地址申请分批发货校验
export const checkApplyPartialShipmentAddressSelection = (params) => axios.post('/partialInvoice/checkApplyPartialShipmentAddressSelection', params);

// 电汇查询-国内电汇查询-召回客户名称修改
export const recallCustomerNameModify = (params) => axios.post('/telApproval/recall', params);
